/**
 * Android Status Bar / Navigation Bar 설정
 * - Status Bar 배경색을 앱 테마(slate-900)에 맞게 설정
 * - 네이티브 플랫폼에서만 동작 (PWA에서는 무시)
 */

import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

/** 앱 테마 색상 (slate-900) */
const THEME_COLOR = "#0f172a";

/**
 * 네이티브 Status Bar 초기화
 * - 배경색: slate-900
 * - 아이콘 스타일: 밝은 색 (어두운 배경에 흰색 아이콘)
 */
export async function initStatusBar(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    // Status Bar 배경색 설정
    await StatusBar.setBackgroundColor({ color: THEME_COLOR });
    // 밝은 텍스트/아이콘 (어두운 배경용)
    await StatusBar.setStyle({ style: Style.Dark });
  } catch {
    // Status Bar 플러그인이 지원되지 않는 환경에서는 무시
  }
}
